export const constants = {
    environment: 'production',
    version: '1.0',
    apiUrl: 'https://api.allcal.com',
    dashboardBaseUrl: 'https://api.dashboard.allcal.com',
    ticketsBaseUrl: 'https://api.tickets.allcal.com',
    ticketsBaseUrlAlt: 'https://purchase.tickets.allcal.com', // has to be purchase.allcal.com for prod
    appBaseUrl: 'https://app.allcal.com',
    templatesBaseUrl: 'http://templates.allcal.com',
    templatesBaseUrlHttps: 'https://templates.allcal.com',
    localhost: 'http://localhost:1338',
    //selectedOrg: "5b2d6803bd2fdd24d0416125",
    //selectedCalendar: "5ed66ba4c7a3244931b42b78",
    selectedOrg: '61305030decd490c26247806',
    selectedCalendar: '6140c463c1e051143a7d12b8',
    paypalEnv: 'production',
    paypalClient: {
        sandbox: 'xyz',
        production: 'Accn6wbpIa1Fh2q3XhNhFGGQRTNXBFcYRvg6E5pLN8xyiN1Qo6BlZMBVPNMk2PtShNHrgJZUCUR__17S',
    }
};
